import { render, staticRenderFns } from "./ClassificationsTap.vue?vue&type=template&id=5ccc0895&"
import script from "./ClassificationsTap.vue?vue&type=script&lang=js&"
export * from "./ClassificationsTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports